import type { IntegrationDefinition } from "./IntegrationsCatalogShared";
import { textField, tokenField } from "./IntegrationsCatalogShared";

export const catalogPart4: IntegrationDefinition[] = [
  {
    kind: "lightspeed_restaurant",
    label: "Lightspeed Restaurant",
    group: "Restaurant operations",
    description:
      "Connect restaurant locations, products, and order data through Lightspeed.",
    setup:
      "Create a Lightspeed Restaurant OAuth token and enter the location you want to use.",
    capabilities: [
      { key: "pos", label: "POS and order data" },
      { key: "orders", label: "Products & orders" },
    ],
    fields: [
      tokenField(
        "Lightspeed access token",
        "An OAuth token with access to the restaurant account.",
      ),
      textField(
        "baseUrl",
        "Lightspeed API URL",
        "Only change this for a different Lightspeed environment.",
        { type: "url", defaultValue: "https://api.lightspeedapp.com" },
      ),
      textField(
        "locationId",
        "Location ID",
        "Optional default restaurant location.",
        { placeholder: "Location ID" },
      ),
    ],
  },
  {
    kind: "deliverect",
    label: "Deliverect",
    group: "Restaurant operations",
    description:
      "Aggregate online food orders and sync menus with restaurant POS systems.",
    setup:
      "Request Deliverect API credentials and enter the account or location identifier.",
    capabilities: [
      { key: "orders", label: "Online orders" },
      { key: "delivery", label: "Delivery status" },
      { key: "pos", label: "POS sync" },
    ],
    fields: [
      tokenField(
        "Deliverect access token",
        "The partner or account token issued by Deliverect.",
      ),
      textField(
        "baseUrl",
        "Deliverect API URL",
        "The Deliverect API base URL for your account.",
        {
          type: "url",
          required: true,
          defaultValue: "https://api.deliverect.com",
        },
      ),
      textField(
        "accountId",
        "Account ID",
        "The Deliverect account identifier.",
        { required: true, placeholder: "Account ID" },
      ),
    ],
  },
];
